<template>
	<v-dialog v-model="localDialog" max-width="653" transition="dialog-transition" content-class="round">
		<div v-if="localDialog">
			<service-selector title="Connect URL" @select-app="selectApp" v-if="stage === 1" />
			<add-cname :app="selectedApp" :loading="loading" v-else-if="selectedApp && stage === 2" @add-cname="addCname" />
		</div>
	</v-dialog>
</template>

<script>
import ServiceSelector from './ServiceSelector';
import AddCname from './AddCname';
import { mapActions } from 'vuex';
export default {
	name: 'CnamesConnectNewDialog',
	components: {
		ServiceSelector,
		AddCname,
	},
	props: {
		showDialog: {
			type: Boolean,
		},
	},
	computed: {},
	methods: {
		...mapActions(['account/addCname']),
		selectApp(app) {
			this.$set(this, 'selectedApp', app);
			this.stage = 2;
		},
		clearData() {
			this.selectedApp = null;
			this.localDialog = false;
		},
		async addCname(payload) {
			this.loading = true;
			await this['account/addCname'](payload);
			this.loading = false;
			this.clearData();
		},
	},
	watch: {
		showDialog: {
			handler(newV) {
				this.localDialog = newV;
				this.stage = 1;
			},
			immediate: true,
		},
		localDialog: {
			handler(newV) {
				this.$emit('update:showDialog', newV);
			},
		},
	},
	data: () => ({
		stage: 1,
		localDialog: null,
		selectedApp: null,
		loading: false,
	}),
	mounted() {},
};
</script>

<style scoped lang="scss"></style>
